export default "__VITE_ASSET__STIEC0X___"